import { render, staticRenderFns } from "./TrainingMaterialForm.vue?vue&type=template&id=634d0fe6&scoped=true"
import script from "./TrainingMaterialForm.vue?vue&type=script&lang=js"
export * from "./TrainingMaterialForm.vue?vue&type=script&lang=js"
import style0 from "./TrainingMaterialForm.vue?vue&type=style&index=0&id=634d0fe6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634d0fe6",
  null
  
)

export default component.exports